import React from 'react';
import PropTypes from 'prop-types';
import { ModalBody } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import PrimaryButton from '../buttons/PrimaryButton';
import useStyles from './styles';


const ServerErrorMessage = ({ onHide, additionalData: error }) => {
  const { t } = useTranslation(['translation', 'COMMON']);
  const classes = useStyles();
  return (
    <ModalBody className={classes.container}>
      <h2 className={classes.header}>{t(`${error?.resource?.toUpperCase() || 'COMMON'}.${error?.errorCode || '0500'}`)}</h2>
      <PrimaryButton onClick={onHide} className={classes.btn}>{t(`COMMON.OK`)}</PrimaryButton>
    </ModalBody>
  );
};


ServerErrorMessage.propTypes = {
  onHide: PropTypes.func.isRequired,
};

export default ServerErrorMessage;
